import { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
  Container,
  BannerPage,
  Content,
  BannerTitle,
  BannerTitleLine,
  BannerTitleWrapper,
  HomeLink,
  Arrow,
  ActiveLink,
  AboutUsWrapper,
  GetInTouch,
  AboutUsDetails,
  GetInTouchDetails,
  WidgetContent,
  InputField,
  Button,
  CaptchaContainer,
  Captcha,
  RefreshButton,
  RefreshIcon,
  Select,
} from "../assets/styled/AccountStyle";
import TopBar from "../component/TopBar";
import Navbar from "../component/Navbar";
import SubFooter from "../component/SubFooter";
import Footer from "../component/Footer";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { COUNTRIES } from "../assets/data/Countries";
import { useAddNewUserMutation } from "../redux/slice/api/usersApiSlice";
import { useNavigate } from "react-router-dom";
import usePersist from "../redux/hooks/usePersist";
import { useLoginMutation } from "../redux/slice/api/authApiSlice";
import { setCredentials } from "../redux/slice/authSlice";
import { useDispatch } from "react-redux";
import CryptoJS from "crypto-js";
import emailjs from "@emailjs/browser";
import BarLoader from "react-spinners/BarLoader";
import BeatLoader from "react-spinners/BeatLoader";

const Account = () => {
  // LOGIN
  const logRef = useRef();
  const errRef = useRef();
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");
  usePersist(true);

  useEffect(() => {
    logRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [loginEmail, loginPassword]);

  const [login, { isLoading }] = useLoginMutation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    try {
      const { accessToken } = await login({
        loginEmail,
        loginPassword,
      }).unwrap();
      dispatch(setCredentials({ accessToken }));
      localStorage.setItem("token", accessToken);
      setLoginEmail("");
      setLoginPassword("");
      navigate("/dashboard/home");
    } catch (err) {
      if (!err.status) {
        setErrMsg("No Server Response");
      } else if (err.status === 400) {
        setErrMsg(err.data?.message);
      } else if (err.status === 401) {
        setErrMsg(err.data?.message);
      } else {
        setErrMsg(err.data?.message);
      }
      errRef.current.focus();
    }
  };

  // REGISTER
  const [addNewUser, { isSuccess, isError, error }] = useAddNewUserMutation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [position, setPosition] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [country, setCountry] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [captchaCode, setCaptchaCode] = useState("");
  const form = useRef();
  const [captcha, setCaptcha] = useState(() => {
    let result = "";
    const length = 6;

    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  });

  const [verificationCode] = useState(() => {
    let result = "";
    const length = 6;

    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  });

  const [hashRoute] = useState(() => {
    let result = "";
    const length = 25;

    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  });

  const [errMsgs, setErrMsgs] = useState("");

  const regRef = useRef();
  const errRefs = useRef();

  useEffect(() => {
    regRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsgs("");
  }, [
    email,
    password,
    confirmPassword,
    firstname,
    lastname,
    position,
    companyName,
    country,
    phoneNumber,
    captchaCode,
  ]);

  const hashEmail = CryptoJS.AES.encrypt(email, "RAKTHERM@2023").toString();

  useEffect(() => {
    if (isSuccess) {
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      setFirstname("");
      setLastname("");
      setPosition("");
      setCompanyName("");
      setCountry("");
      setPhoneNumber("");
      localStorage.setItem("email-token", hashEmail);
      localStorage.setItem("verification-token", hashRoute);
      localStorage.setItem("verification-code", verificationCode);
      navigate(`/account-verification/${hashRoute}`);
    }
  }, [isSuccess, navigate]);

  const handleCaptcha = () => {
    let result = "";
    const length = 6;

    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    setCaptcha(result);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !email ||
      !password ||
      !confirmPassword ||
      !firstname ||
      !lastname ||
      !position ||
      !companyName ||
      !country ||
      !phoneNumber
    ) {
      setErrMsgs("All fields are required!");
    } else {
      if (password !== confirmPassword) {
        setErrMsgs("Password does not match!");
      } else if (captcha !== captchaCode) {
        setErrMsgs("Invalid captcha code!");
      } else {
        emailjs
          .sendForm(
            "service_radlyhj",
            "template_0nktc75",
            form.current,
            "GOSNKTcFgAf4ET6zy"
          )
          .then(
            (result) => {
              console.log(result.text);
              console.log("message sent");
            },
            (error) => {
              console.log(error.text);
            }
          );

        await addNewUser({
          email,
          password,
          firstname,
          lastname,
          position,
          companyName,
          country,
          phoneNumber,
          verificationCode,
        });
      }
    }
  };

  return (
    <>
      <TopBar />
      <Navbar />
      <BannerPage>
        <Container>
          <Content>
            <AboutUsWrapper>
              <AboutUsDetails>
                <BannerTitleWrapper>
                  <BannerTitle>
                    <BannerTitleLine>|</BannerTitleLine>LOGIN & REGISTER
                  </BannerTitle>
                </BannerTitleWrapper>
              </AboutUsDetails>
              <GetInTouchDetails>
                <GetInTouch>GET IN TOUCH</GetInTouch>
              </GetInTouchDetails>
            </AboutUsWrapper>

            <HomeLink to="/">
              Home{" "}
              <Arrow>
                <MdOutlineKeyboardArrowRight />
              </Arrow>{" "}
              <ActiveLink>My RAKtherm</ActiveLink>
            </HomeLink>
          </Content>
        </Container>

        <WidgetContent>
          <Container>
            <TitleWrapper>
              <LineTitle>|</LineTitle>
              <Title>LOGIN & REGISTER</Title>
            </TitleWrapper>
            <Div>
              <ItalicText>
                Interact With Fellow Technician, And See If We Were Able To Help
                You Through Our Training With RAKtherm Global Academy.
              </ItalicText>
            </Div>

            <AccountWrapper>
              <Panel>
                <div class="blog-detail-wrapper">
                  <div class="comment-respond">
                    <h3 class="title">Login</h3>

                    {isLoading ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingBottom: "20px",
                          flexDirection: "column",
                        }}
                      >
                        <BarLoader
                          color="#008053"
                          cssOverride={null}
                          height={10}
                          speedMultiplier={0.5}
                          width={300}
                        />
                        <div style={{ paddingTop: "20px" }}>
                          <h3 class="title" style={{ display: "flex" }}>
                            Please wait while we are processing your account...
                          </h3>
                        </div>
                      </div>
                    ) : (
                      <>
                        <p
                          ref={errRef}
                          style={{ color: "red", paddingBottom: "15px" }}
                          aria-live="assertive"
                        >
                          {errMsg}
                        </p>
                        <div class="contact-form-2"></div>
                        <form onSubmit={handleSubmitLogin}>
                          <InputField
                            placeholder="Email"
                            ref={logRef}
                            value={loginEmail}
                            onChange={(e) => setLoginEmail(e.target.value)}
                          />
                          <InputField
                            type="password"
                            placeholder="Password"
                            value={loginPassword}
                            onChange={(e) => setLoginPassword(e.target.value)}
                          />

                          <Button
                            style={{
                              width: "15%",
                              marginRight: "10px",
                              marginBottom: "20px",
                            }}
                          >
                            Login
                          </Button>
                          <a href="index.php?module=forgotpass">
                            Forget Password
                          </a>
                        </form>
                      </>
                    )}
                  </div>
                </div>
              </Panel>

              <Panel>
                <div class="blog-detail-wrapper">
                  <div class="comment-respond">
                    <h3 class="title">Register</h3>
                    <p
                      ref={errRefs}
                      style={{ color: "red", paddingBottom: "15px" }}
                    >
                      {error?.data?.message} {errMsgs}
                    </p>
                    <div class="contact-form-2"></div>
                    <form ref={form} onSubmit={handleSubmit}>
                      <InputField
                        placeholder="Email*"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        ref={regRef}
                        name="email"
                      />
                      <InputField
                        placeholder="Password*"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <InputField
                        value={verificationCode}
                        style={{ display: "none" }}
                        name="verificationCode"
                      />
                      <InputField
                        placeholder="Confirm Password*"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <InputField
                        placeholder="First Name*"
                        name="firstname"
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                      />
                      <InputField
                        placeholder="Last Name*"
                        name="lastname"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                      />
                      <InputField
                        placeholder="Job Position*"
                        value={position}
                        onChange={(e) => setPosition(e.target.value)}
                      />
                      <InputField
                        placeholder="Company Name*"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                      <Select
                        placeholder="Select Country*"
                        onChange={(e) => setCountry(e.target.value)}
                        value={country}
                      >
                        {COUNTRIES.map((data) => (
                          <>
                            <option value={data.name}>{data.name}</option>
                          </>
                        ))}
                      </Select>
                      <InputField
                        placeholder="Phone Number*"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                      />
                      <CaptchaContainer>
                        <Captcha style={{ width: "20%" }} on>
                          {captcha}
                        </Captcha>
                        <RefreshButton onClick={handleCaptcha}>
                          <RefreshIcon />
                        </RefreshButton>
                      </CaptchaContainer>
                      <InputField
                        placeholder="Enter Captcha Here"
                        value={captchaCode}
                        onChange={(e) => setCaptchaCode(e.target.value)}
                      />
                      <Button style={{ width: "20%", marginBottom: "20px" }}>
                        Register
                      </Button>
                    </form>
                  </div>
                </div>
              </Panel>
            </AccountWrapper>
          </Container>
        </WidgetContent>
      </BannerPage>
      <SubFooter />
      <Footer />
    </>
  );
};

const TitleWrapper = styled.div`
  display: flex;
  padding-top: 25px;
`;

const ItalicText = styled.span`
  font-size: 16px;
  font-weight: 400;
  font-style: italic;
  margin: 0;
  text-transform: capitalize;
  color: #aab7ca;
`;

const LineTitle = styled.span`
  text-align: left;
  position: relative;
  color: #008053;
  font-size: 27px;
  font-weight: 900;
`;

const Title = styled.p`
  text-align: left;
  position: relative;
  color: #3a4d6a;
  font-size: 30px;
  font-weight: 700;
  padding: 0px 0px 0px 10px;
`;

const Div = styled.div``;

const AccountWrapper = styled.div`
  display: flex;
  margin: 50px 0px;
`;

const Panel = styled.div`
  flex: 1;
  padding: 20px;
`;

export default Account;
